import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, C } from "../lib/api";

const bundleOf = (html) => (html.match(/static\/js\/main\.[0-9a-f]+\.js/) || [])[0] || "";
const mine = bundleOf(document.documentElement.innerHTML);
const atTable = (path) => path.startsWith("/table/");

// A tab left open across a deploy runs the old bundle. Away from a table it reloads itself onto the new build;
// at a table it waits for the next page change (never mid-hand). A contract/protocol change still says so at once.
export const VersionWatch = () => {
  const { pathname } = useLocation();
  const stale = useRef(false);
  const path = useRef(pathname);

  useEffect(() => {
    if (path.current !== pathname && stale.current) { window.location.reload(); return; }
    path.current = pathname;
    if (stale.current && !atTable(pathname)) window.location.reload();
  }, [pathname]);

  useEffect(() => {
    let warned = false;
    const check = () => {
      if (mine) {
        fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" }).then((r) => r.text()).then((html) => {
          const live = bundleOf(html);
          if (!live || live === mine) return;
          stale.current = true;
          if (!atTable(path.current)) window.location.reload();
        }).catch(() => {});
      }
      api.get("/api/health").then((r) => {
        const off = (r.data.contracts && r.data.contracts !== C.CONTRACTS_VERSION) || (r.data.protocol && r.data.protocol !== C.PROTOCOL_VERSION);
        if (!off || warned) return;
        warned = true;
        toast.info("Players Room has been updated", {
          description: "Reload to pick up the new version — your seat and chips are not affected.",
          duration: Infinity,
          action: { label: "Reload", onClick: () => window.location.reload() },
        });
      }).catch(() => {});
    };
    check();
    const id = setInterval(check, 60000);
    return () => clearInterval(id);
  }, []);
  return null;
};
